import { Decimal } from 'decimal.js'

export function decimalAdding(a, b, prec) {
  return parseFloat(new Decimal(a.toString()).add(b.toString()).toFixed(prec))
}
